export default "__VITE_ASSET__b734faf1__"